import React from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import SelectField, {
	type SelectFieldProps,
} from '../../common/ui/fields/base-fields/select-field/index.tsx';
import SingleSelectFieldWithAnalytics from './SingleSelectFieldWithAnalytics.tsx';

const SingleSelectField = (props: SelectFieldProps): React.JSX.Element => (
	<SelectField {...props} isMulti={false} closeMenuOnSelect />
);

export default componentWithFG(
	'add_analytic_priority_field_gic_ken-3538',
	SingleSelectFieldWithAnalytics,
	SingleSelectField,
);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateSingleSelectField, mapSelectOptionsToConnectData } from './utils';
